var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 1.03899C1.31658 0.648463 0.683417 0.648463 0.292893 1.03899C-0.0976311 1.42951 -0.0976311 2.06268 0.292893 2.4532L4.58579 6.74609L0.292893 11.039C-0.0976311 11.4295 -0.0976311 12.0627 0.292893 12.4532C0.683417 12.8437 1.31658 12.8437 1.70711 12.4532L6 8.16031L10.2929 12.4532C10.6834 12.8437 11.3166 12.8437 11.7071 12.4532C12.0976 12.0627 12.0976 11.4295 11.7071 11.039L7.41421 6.74609L11.7071 2.4532C12.0976 2.06268 12.0976 1.42951 11.7071 1.03899C11.3166 0.648463 10.6834 0.648463 10.2929 1.03899L6 5.33188L1.70711 1.03899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c3fc39be0750d1385da4a7aea502ce1d.svg";
export { ForwardRef as ReactComponent };